/**
 * @author: dwi.setiyadi@gmail.com
*/

import React from 'react';

export const CompanyName = 'Interport';
export const ProjectName = 'Interport Lintas';

export const Layout = React.lazy(() => import('../components/containers/DefaultLayout'));

export const APIUri = 'https://api.themoviedb.org/3/';
export const APIKey = '2cd60e70e23d1aac41f24a242c1e08f8';
